<template>
  <div :class="isServer ? 'isServer' : 'isClient'">
    <button @click="toggle()" class="stageborderButton" value="show me">
      {{ buttonText }}
    </button>
    <div
      class="stageborder"
      :style="{ visibility: isVisible ? 'visible' : 'hidden' }"
    ></div>
  </div>
</template>

<script>
import api from "@/api/orderkiosk";

const BUTTON_TEXT_SHOW = "Show stage";
const BUTTON_TEXT_HIDE = "Hide stage";
export default {
  name: "StageBorder",
  data() {
    return {
      isServer: false,
      isVisible: false,
      buttonText: BUTTON_TEXT_SHOW
    };
  },
  created() {
    let self = this;
    api.getServerInfo().then(r => {
      if (r.data.isServer) {
        self.isServer = true;
      }
    });
  },
  methods: {
    toggle() {
      console.log("toggle");
      this.buttonText = this.isVisible ? BUTTON_TEXT_SHOW : BUTTON_TEXT_HIDE;
      this.isVisible = !this.isVisible;
    }
  }
};
</script>

<style lang="scss" scoped>
.isClient {
  display: none;
}

.isServer {
  display: block;
}

.stageborder {
  position: absolute;
  border-left: 2px solid red;
  border-right: 2px solid red;
  border-bottom: 2px solid red;
  top: 0px;
  left: 182px;
  width: 716px;
  height: 625px;
  z-index: 100;
}

.stageborderButton {
  font-size: 25px;
  position: absolute;
  right: 0;
  width: 150px;
  height: 50px;
  z-index: 101;
}
</style>
